/** CoStar.Api.MarketAnalytics.AnalyticExport.Models.DisplayRentAs */
export var DisplayRentAs;
(function (DisplayRentAs) {
    DisplayRentAs[DisplayRentAs["Annual"] = 1] = "Annual";
    DisplayRentAs[DisplayRentAs["Monthly"] = 2] = "Monthly";
})(DisplayRentAs || (DisplayRentAs = {}));
/** CoStar.Api.MarketAnalytics.AnalyticExport.Models.Distance */
export var Distance;
(function (Distance) {
    Distance[Distance["Miles"] = 0] = "Miles";
    Distance[Distance["Kilometers"] = 1] = "Kilometers";
})(Distance || (Distance = {}));
/** CoStar.Api.MarketAnalytics.AnalyticExport.Models.Area */
export var Area;
(function (Area) {
    Area[Area["SquareFeet"] = 0] = "SquareFeet";
    Area[Area["SquareMeters"] = 1] = "SquareMeters";
})(Area || (Area = {}));
